module.exports = __webpack_public_path__ + "static/img/groundabout.a79fcf0b.png";